module.exports = __webpack_public_path__ + "static/workshop_illustration-af74fb8fd63a05bc84621b77424d1bdf.png";